const config ={
    endpointUrl :String(import.meta.env.VITE_API_ENDPOINT),
    apiSecretId :String(import.meta.env.VITE_API_SECRET_ID),
}
export default config;